import {downloadJsonAsCSV} from '../../../../../js/csv/utils'
import messageResource from '../../../../../js/messageResource'
import {DateFormat} from '../../../../../js/date_format'
import _ from 'underscore'
import {columnValue, columnValueOrHyphen, formatNumber, nameWithArchivedMark} from '../../../../../js/csv/format'
import EntityProvider from './EntityProvider'
import UserNameFormat from '../../../../../js/util/UserNameFormat'

export function downloadLeaveRequestsListCsv(data, props, callback) {

    const provider = new EntityProvider(props)
    const json = {
        columnNames: csvColumnNames(),
        columns: csvColumns(data),
        table: csvRows(data, provider)
    }
    let fileName = messageResource.getMessage("actiplans.corporate_requests.list.export_name.csv",
        [new DateFormat('MMM dd, yyyy').formatDate(window.currentUserTime())])
    downloadJsonAsCSV([json], fileName, callback)
}

function csvColumnNames() {
    const days = [messageResource.getMessage("common.balance_units.days")]
    const hours = [messageResource.getMessage("common.balance_units.hours")]
    return {
        user: messageResource.getMessage("common.User"),
        userGroup: messageResource.getMessage("common.User_Group"),
        tzGroup: messageResource.getMessage("common.Time_Zone_Group"),
        leaveType: messageResource.getMessage("leave_type.leave_type"),
        startDate: messageResource.getMessage("common.start_date"),
        endDate: messageResource.getMessage("common.end_date"),
        daysRequested: messageResource.getMessage("actiplans.leave_time_requests.time_requested_with_units", days),
        hoursRequested: messageResource.getMessage("actiplans.leave_time_requests.time_requested_with_units", hours),
        userComment: messageResource.getMessage("actiplans.leave_time_requests.csv.user_comment"),

        balanceType: messageResource.getMessage("actiplans.leave_time_requests.balance_type"),
        balanceDaysBefore: messageResource.getMessage("actiplans.leave_time_requests.balance_before", days),
        balanceDaysAfter: messageResource.getMessage("actiplans.leave_time_requests.balance_after", days),
        balanceHoursBefore: messageResource.getMessage("actiplans.leave_time_requests.balance_before", hours),
        balanceHoursAfter: messageResource.getMessage("actiplans.leave_time_requests.balance_after", hours),

        status: messageResource.getMessage("actiplans.leave_time_requests.status"),
        statusDate: messageResource.getMessage("actiplans.leave_time_requests.csv.status_date"),
        manager: messageResource.getMessage("actiplans.leave_time_requests.csv.manager"),
        managerComment: messageResource.getMessage("actiplans.leave_time_requests.csv.manager_note"),

        balanceChangePTO: messageResource.getMessage("actiplans.leave_time_requests.csv.change_current_balance.pto"),
        balanceChangeSick: messageResource.getMessage("actiplans.leave_time_requests.csv.change_current_balance.sick")
    }
}

function hasChangedTodayBalance({request, userInfo}) {
    return LeaveTimeRequestUtils.changedTodayBalanceObjectNotEmpty(
        LeaveTimeRequestUtils.getBalanceValueFromRequestWithChanges(request, userInfo).changedTodayBalance
    )
}

function csvColumns(data) {
    let columns = Object.keys(csvColumnNames())

    if (!data.userGroupsEnabled) columns = _.without(columns, "userGroup")
    if (!data.timeZoneGroupsEnabled) columns = _.without(columns, "tzGroup")

    if (!SystemSettings.apPtoBalanceCalculationEnabled && !SystemSettings.apSickBalanceCalculationEnabled) {
        columns = _.reject(columns, (c) => c.startsWith("balance"))
    }

    if (!SystemSettings.apPtoBalanceCalculationEnabled) columns = _.without(columns, "balanceChangePTO")
    if (!SystemSettings.apSickBalanceCalculationEnabled) columns = _.without(columns, "balanceChangeSick")

    if (!data.records.some(rec => hasChangedTodayBalance(rec))) {
        columns = _.without(columns, "balanceChangePTO", "balanceChangeSick")
    }

    return columns
}

function csvRows(data, provider) {

    return data.records.map(({request, userInfo}) => {
        const status = LeaveTimeRequestUtils.getStatusFromRequestWithChanges(request)
        const targetLeaveType = provider.getLeaveType(LeaveTimeRequestUtils.getLeaveTypeIdFromRequestWithChanges(request))
        const originalLeaveType = provider.getLeaveType(request.leaveTypeId)
        const balance = LeaveTimeRequestUtils.getBalanceValueFromRequestWithChanges(request, userInfo)

        let canUseBalanceChangeForTargetLeaveType =
            (targetLeaveType.id === originalLeaveType.id) ||
            (targetLeaveType.balanceType === originalLeaveType.balanceType && (
                targetLeaveType.ptoCoefficient === originalLeaveType.ptoCoefficient
                || targetLeaveType.balanceType !== BalanceType.PTO
            ))

        let {after, before} = canUseBalanceChangeForTargetLeaveType ? balance: {}


        return {
            user: UserNameFormat.formatLFM(userInfo.firstName, userInfo.lastName, userInfo.middleInitial),
            userGroup: data.userGroupsEnabled ? nameWithArchivedMark(provider.getUserGroup(userInfo.userGroupId)) : null,
            tzGroup: data.timeZoneGroupsEnabled ? nameWithArchivedMark(provider.getTimeZoneGroup(userInfo.timeZoneGroupId)) : null,
            leaveType: nameWithArchivedMark(targetLeaveType),

            startDate: columnValue(request.firstDate, formatDate),
            endDate: columnValue(request.lastDate, formatDate),
            daysRequested: columnValue(LeaveTimeRequestUtils.getLeaveTimeTotalValueFromRequestWithChanges(request).days, formatNumber),
            hoursRequested: columnValue(LeaveTimeRequestUtils.getLeaveTimeTotalValueFromRequestWithChanges(request).hours),
            userComment: columnValueOrHyphen(LeaveTimeRequestUtils.getCommentFromRequestWithChanges(request)),

            balanceType: columnValueOrHyphen(formatBalanceType(targetLeaveType)),

            balanceDaysBefore: columnValueOrHyphen(before, formatNumber),
            balanceDaysAfter: columnValueOrHyphen(after, formatNumber),
            balanceHoursBefore: columnValueOrHyphen(before, days => days * data.ptoHoursPerDay),
            balanceHoursAfter: columnValueOrHyphen(after, days => days * data.ptoHoursPerDay),

            status: columnValue(LeaveTimeRequestUtils.formatLeaveRequestStatus(status)),
            statusDate: columnValue(status.statusDate, formatDate),
            manager: columnValueOrHyphen(LeaveTimeRequestUtils.formatLeaveRequestApprovedBy(status, false)),
            managerComment: columnValueOrHyphen(status.statusMessage),

            balanceChangePTO: columnValueOrHyphen(balance.changedTodayBalance.PTOBalance, formatNumber),
            balanceChangeSick: columnValueOrHyphen(balance.changedTodayBalance.sickBalance, formatNumber)

        }
    })
}

function formatBalanceType(leaveType) {
    switch (leaveType.balanceType) {
        case BalanceType.PTO:
            return messageResource.getMessage("actiplans.leaves_management.balance.pto")
        case BalanceType.SICK:
            return messageResource.getMessage("actiplans.leaves_management.balance.sick")
    }


}


const leaveRequestsCsvdateFormat = new DateFormat("MMM dd, yyyy")

function formatDate(val) {
    return leaveRequestsCsvdateFormat.formatDate(Date.parseJSONDate(val))
}



// WEBPACK FOOTER //
// ./web/actiplans/js/administration/corporateRequests/exportToCsv/exporter.js